import { v4 } from 'uuid';

const questions = {
  create_type: {
    id: v4(),
    title: 'Choose your form type',
    description:
      'Patient-facing forms are sent directly to patients, while clinical templates are filled out by providers within clinical notes. Patient forms can be integrated into clinical notes, and clinical templates can also be shared with patients to streamline data collection for encounters.',
    answers: [
      {
        id: v4(),
        title: 'Patient-facing forms',
        description: 'Can be integrated with your clinical note.',
        value: 'patient_facing_form'
      },
      {
        id: v4(),
        title: 'Clinical template',
        description: 'Can be sent to patients if added to a form packet.',
        value: 'clinical_template'
      }
    ]
  },
  clinical_template: {
    existing: {
      id: v4(),
      title: 'Will this clinical template be used for existing or new patients?',
      description:
        'Please note that when integrating patient forms into the clinical note, AI-narratives will be generated based on the data that is inputted in order to save you time and eliminate redundancies.',
      answers: [
        {
          id: v4(),
          title: 'Existing patients',
          description: 'This will be a progress note format.',
          value: true
        },
        {
          id: v4(),
          title: 'New patients',
          description:
            'This will be an intake note format, will also apply to patients who have not visited in 12 months.',
          value: false
        }
      ]
    }
  },
  patient_facing_form: {
    integrate: {
      id: v4(),
      title: 'How do you want to integrate this form?',
      description:
        'When integrating patient forms into clinical notes, AI-enhanced narratives will be created based on approved data only. This will save time and eliminate redundancies.',
      answers: [
        {
          id: v4(),
          title: 'Sync with clinical note',
          description: 'Integrate patient responses within my narratives.',
          value: true
        },
        {
          id: v4(),
          title: 'Do not integrate for now',
          description: 'This can always be set up later.',
          value: false
        }
      ]
    },
    receive: {
      id: v4(),
      title: 'When will patients receive forms?',
      description:
        'Decide to integrate patient forms into the intake or progress section of your clinical note.',
      answers: [
        {
          id: v4(),
          title: 'Every visit',
          description: '',
          value: true
        },
        {
          id: v4(),
          title: 'First visit or every 12 months',
          description: '',
          value: false
        }
      ]
    }
  }
};

export default questions;
